import { render, staticRenderFns } from "./sortCount.vue?vue&type=template&id=a64de664&scoped=true&"
import script from "./sortCount.vue?vue&type=script&lang=js&"
export * from "./sortCount.vue?vue&type=script&lang=js&"
import style0 from "./sortCount.vue?vue&type=style&index=0&id=a64de664&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a64de664",
  null
  
)

export default component.exports